import { GridColDef } from '@mui/x-data-grid-pro';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { formatDate } from '../../../components/formatUtils/dateFormatUtils';
import { AppDataGrid } from '../../../components/table/AppDataGrid';
import { KundeLink } from '../../kunde/components/KundeLink';
import { MitarbeiterLink } from '../../mitarbeiter/components/MitarbeiterLink';
import { useFindAllProjektOfMitarbeiterQuery } from '../api/projektApi';

const projektTableColumns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 3,
  },
  {
    field: 'kurzbeschreibung',
    headerName: 'Kurzbeschreibung',
    flex: 4,
    type: 'string',
  },
  {
    field: 'kundeId',
    headerName: 'Kunde',
    flex: 2,
    renderCell: params => <KundeLink id={params.value} />,
  },
  {
    field: 'projektLeiterId',
    headerName: 'Projektleiter',
    flex: 2,
    renderCell: params => params.value && <MitarbeiterLink id={params.value} />,
  },
  {
    field: 'rechnungszyklus',
    headerName: 'Rechnungszyklus',
    flex: 2,
    type: 'number',
  },
  {
    field: 'istPauschal',
    headerName: 'Pauschal',
    flex: 1,
    type: 'boolean',
  },
  {
    field: 'istPausiert',
    headerName: 'Pausiert',
    flex: 1,
    type: 'boolean',
  },
  {
    field: 'istArchiviert',
    headerName: 'Archiviert',
    flex: 1,
    type: 'boolean',
  },
  {
    field: 'creationDate',
    headerName: 'Angelegt am',
    flex: 1,
    type: 'date',
    valueFormatter: value => formatDate(value as string),
  },
];

interface ProjektTableForMitarbeiterProps {
  mitarbeiterId: string;
}

export const ProjektTableForMitarbeiter: FC<ProjektTableForMitarbeiterProps> = ({
  mitarbeiterId,
}) => {
  const navigate = useNavigate();
  const { data, isFetching } = useFindAllProjektOfMitarbeiterQuery({ mitarbeiterId });

  return (
    <AppDataGrid
      onRowClick={params => navigate(`/intern/projekte/${params.id}`)}
      loading={isFetching}
      columns={projektTableColumns}
      rows={data?.data ?? []}
    />
  );
};
